import React, { useState, useEffect } from "react"
import textData from "../../data/textData"
import AnswerTemplate from "../templates/answer-template"
import ModalWindow from "../organisms/modal-window"
import Layout from "../layout"

const Answer = props => {
  let toNext
  let buttonText
  if (props.index === 9) {
    toNext = props.toResult
    buttonText = "結果発表！"
  } else {
    toNext = props.toQuestion
    buttonText = "次の問題に挑戦！"
  }
  let aText
  if (props.resultList[props.index]) {
    aText = "おめでとう！"
  } else {
    aText = "惜しい〜！"
  }

  const randomNo = 1 + Math.floor(Math.random() * 4)
  const Props = {
    index: props.index,
    resultList: props.resultList,
    gImageNameASP: `aUme0${randomNo}SP`,
    gImageNameAPC: `aUme0${randomNo}PC`,
    gImageNameIASP: `iaUme0${randomNo}SP`,
    gImageNameIAPC: `iaUme0${randomNo}PC`,
    qImagename: "qImage" + textData[props.index].no,
    data: textData[props.index],
    toNext: toNext,
    toIndex: props.toIndex,
    aText: aText,
    correct: props.resultList[props.index],
    buttonText: buttonText,
  }
  const [isModal, setModal] = useState(false)
  const resultList = props.resultList
  let Modal
  useEffect(() => {
    var tmpCount = 0
    for (let i = 0; i <= props.index; i++) {
      if (resultList[i]) {
        tmpCount = tmpCount + 1
      } else {
        tmpCount = 0
      }
    }
    // test 1 => 3
    if (tmpCount % 3 === 0 && tmpCount !== 0 && props.index !== 9) {
      setTimeout(() => setModal(true), 1000)
    }
  }, [])

  if (isModal) {
    Modal = <ModalWindow index={props.index} />
  }

  return (
    <Layout>
      <AnswerTemplate {...Props} />
      {Modal}
    </Layout>
  )
}

export default Answer
